/* eslint-disable no-control-regex */
// from https://emailregex.com
export const EMAIL_PATTERN =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const isEmail = (value: string): boolean => EMAIL_PATTERN.test(value)

export const URL_DETECTOR = new RegExp(
  '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?',
)

export const includesUrl = (value: string): boolean => URL_DETECTOR.test(value)

export const isValidRedirectUri = (value: string): boolean =>
  value && value.length > 0 && value.startsWith('/') && !value.startsWith('//')

/**
 * Regular expression to filter out invalid characters in domain entries.
 * Using the same approach as Helmet for validating CSP frame-ancestors domains.
 * Semicolons and commas are not allowed as they have special meaning in CSP headers.
 */
export const INVALID_FRAME_ANCESTORS_REGEX = /;|,/
